webpackJsonp([3],{

/***/ "+Fcr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+l4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bean__ = __webpack_require__("LoZg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qwery__ = __webpack_require__("h437");


__WEBPACK_IMPORTED_MODULE_0_bean___default.a.setSelectorEngine(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_bean___default.a);

/***/ }),

/***/ "/UWE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("aEn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__makosh_assets_components_popup_popup__ = __webpack_require__("F8dO");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var SWFPopup = function (_Popup) {
    _inherits(SWFPopup, _Popup);

    function SWFPopup() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, SWFPopup);

        var _this = _possibleConstructorReturn(this, (SWFPopup.__proto__ || Object.getPrototypeOf(SWFPopup)).call(this, { noInit: true }));

        _this.init(Object.assign({
            class: 'swf-popup group',
            content: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.template('<object width="<%- width %>" height="<%- height %>">' + '<param name="movie"' + ' value="<%- url %>">' + '<embed src="<%- url %>"' + ' width="<%- width %>" height="<%- height %>">' + '</object>')(options)
        }, options));
        return _this;
    }

    return SWFPopup;
}(__WEBPACK_IMPORTED_MODULE_1__makosh_assets_components_popup_popup__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SWFPopup);

/***/ }),

/***/ "1JVx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("aEn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bean__ = __webpack_require__("+l4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_button__ = __webpack_require__("rtXA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_link_button__ = __webpack_require__("Boeu");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }








var Buttons = function () {
    function Buttons(el) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Buttons);

        this._options = options;
        this.$el = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(document.createElement('div'));
        this.$el.attr('class', 'b-popup-buttons');
        this.$el.html(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.template('<% var tag = options["okButton"] == "button" ? "span" : "a" %>' + '<<%- tag %> role="<%- options["okButton"]["role"] %>"' + ' class="ok-button b-button">' + '<span class="fleck"></span>' + '<%- options["okButton"]["label"] %>' + '</<%- tag %>>' + '<% if (options["cancelButton"]) { %>' + '<% var tag = options["cancelButton"] == "button" ? "span" : "a" %>' + '<<%- tag %> role="<%- options["cancelButton"]["role"] %>"' + ' class="cancel-link-button">' + '<%- options["cancelButton"]["label"] %>' + '</<%- tag %>>' + '<% } %>')({ options: this._options }));
        Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(el).replaceWith(this.$el);

        this.$okButton = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])('.ok-button', this.$el);
        this.$cancelLinkButton = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])('.cancel-link-button', this.$el);
        var okButton = new __WEBPACK_IMPORTED_MODULE_3__components_button__["a" /* default */](this.$okButton);
        var cancelLinkButton = this.$cancelLinkButton.length ? new __WEBPACK_IMPORTED_MODULE_4__components_link_button__["a" /* default */](this.$cancelLinkButton) : null;

        __WEBPACK_IMPORTED_MODULE_2__bean__["a" /* default */].on(this.$okButton[0], 'press', this._options['okButton']['onPress']);
        if (this.$cancelLinkButton.length) __WEBPACK_IMPORTED_MODULE_2__bean__["a" /* default */].on(this.$cancelLinkButton[0], 'press', this._options['cancelButton']['onPress']);
    }

    _createClass(Buttons, [{
        key: 'press',
        value: function press(button) {
            return button == 'ok-button' ? this._options['okButton']['onPress']() : this._options['cancelButton']['onPress']();
        }
    }]);

    return Buttons;
}();

/* harmony default export */ __webpack_exports__["a"] = (Buttons);

/***/ }),

/***/ "BTMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bean__ = __webpack_require__("+l4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_popup_viewport__ = __webpack_require__("xjfE");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Manager = function () {
    function Manager() {
        _classCallCheck(this, Manager);

        this._mode = 'hideViewportScrollbars';
        if (this.mode() == 'hideViewportScrollbars') this._viewport = new __WEBPACK_IMPORTED_MODULE_1__components_popup_viewport__["a" /* default */]();
    }

    _createClass(Manager, [{
        key: 'adopt',
        value: function adopt(popup) {
            var _this = this;

            if (this.mode() == 'hideViewportScrollbars') this._viewport.hideScrollbars();
            this._popup = popup;
            this._popup.options({
                mode: this.mode(),
                noPopupScrollbarState: this._viewport ? this._viewport.noPopupScrollbarState.bind(this._viewport) : null,
                afterShow: function afterShow() {
                    _this.__keydownEventHandler = _this._keydownEventHandler.bind(_this);
                    __WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].on(window, 'keydown', _this.__keydownEventHandler);
                    __WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].fire(popupManager, 'afterShow');
                },
                onUpdateExtents: function onUpdateExtents(event) {
                    __WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].fire(popupManager, 'updateExtents', event);
                },
                beforeDestroy: function beforeDestroy() {
                    __WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].fire(popupManager, 'beforeDestroy');
                    __WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].off(window, 'keydown', _this.__keydownEventHandler);
                },
                afterDestroy: function afterDestroy() {
                    _this._popup = null;
                    if (_this.mode() == 'hideViewportScrollbars') _this._viewport.showScrollbars();
                    __WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].fire(popupManager, 'afterDestroy');
                }
            });
        }
    }, {
        key: '_keydownEventHandler',
        value: function _keydownEventHandler(e) {
            if (!this._popup) return;
            switch (e.key) {
                case 'Enter':
                    if (e.originalEvent.enterHasBeenHandled) {
                        break;
                    }
                    if (e.target.tagName == 'TEXTAREA') break;
                    if (this._popup.onEnter() == false) break;
                    this._popup.destroy();
                    break;

                case 'Escape':
                    this._popup.destroy();
                    break;
            }
        }
    }, {
        key: 'markEnterAsHandled',
        value: function markEnterAsHandled(e) {
            if (e.key != 'Enter') return;
            e.originalEvent.enterHasBeenHandled = true;
        }
    }, {
        key: '_resizeEventHandler',
        value: function _resizeEventHandler() {
            if (this.mode() == 'hideViewportScrollbars') this._viewport.updateExtents();
            this._popup.updateExtents('windowResize');
        }
    }, {
        key: 'noPopupPageXOffset',
        value: function noPopupPageXOffset() {
            return this._viewport.noPopupPageXOffset();
        }
    }, {
        key: 'noPopupPageYOffset',
        value: function noPopupPageYOffset() {
            return this._viewport.noPopupPageYOffset();
        }
    }, {
        key: 'noPopupViewportClientWidth',
        value: function noPopupViewportClientWidth() {
            return this._viewport.noPopupClientWidth();
        }
    }, {
        key: 'noPopupViewportClientHeight',
        value: function noPopupViewportClientHeight() {
            return this._viewport.noPopupClientHeight();
        }
    }, {
        key: 'popupShown',
        value: function popupShown() {
            return this._popup && this._popup.shown();
        }
    }, {
        key: 'popupBoundingClientRect',
        value: function popupBoundingClientRect() {
            return this._popup && this._popup.getBoundingClientRect();
        }
    }, {
        key: 'mode',
        value: function mode() {
            return this._mode;
        }
    }]);

    return Manager;
}();

var popupManager = new Manager();
/* harmony default export */ __webpack_exports__["a"] = (popupManager);

__WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].on(window, 'resize', function (e) {
    if (popupManager.popupShown()) popupManager._resizeEventHandler(e);else __WEBPACK_IMPORTED_MODULE_0__bean__["a" /* default */].fire(popupManager, 'updateExtents', 'windowResize');
});

/***/ }),

/***/ "Boeu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_button__ = __webpack_require__("rtXA");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var LinkButton = function (_Button) {
    _inherits(LinkButton, _Button);

    function LinkButton() {
        _classCallCheck(this, LinkButton);

        return _possibleConstructorReturn(this, (LinkButton.__proto__ || Object.getPrototypeOf(LinkButton)).apply(this, arguments));
    }

    _createClass(LinkButton, [{
        key: '_shouldFirePress',
        value: function _shouldFirePress(key) {
            return ['Enter'].includes(key);
        }
    }]);

    return LinkButton;
}(__WEBPACK_IMPORTED_MODULE_0__components_button__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (LinkButton);

/***/ }),

/***/ "F8dO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("aEn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__front_end_vars__ = __webpack_require__("uvj3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__("IMjp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bean__ = __webpack_require__("+l4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_popup_overlay__ = __webpack_require__("kAvu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_popup_wrapper__ = __webpack_require__("IoA1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_popup_manager__ = __webpack_require__("BTMb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_popup_header__ = __webpack_require__("zweD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_popup_buttons__ = __webpack_require__("1JVx");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }













var Popup = function () {
    function Popup() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Popup);

        if (options['noInit']) return;
        this.init(options);
    }

    _createClass(Popup, [{
        key: 'init',
        value: function init(options) {
            var _this = this;

            this._options = {};
            __WEBPACK_IMPORTED_MODULE_7__components_popup_manager__["a" /* default */].adopt(this);
            this.options(options);
            this._overlay = new __WEBPACK_IMPORTED_MODULE_5__components_popup_overlay__["a" /* default */]({
                onClick: this.destroy.bind(this)
            });

            this.$el = Object(__WEBPACK_IMPORTED_MODULE_3__qwery__["a" /* default */])(document.createElement('div'));
            this.$el.attr('class', ['b-popup', 'b-frame'].concat([this.options('mode') == 'hideViewportScrollbars' ? 'position-static' : 'position-fixed'], this.options('class') instanceof Array ? this.options('class') : [this.options('class')]).join(' '));
            this.$el.css('visibility', 'hidden');
            this.$el.html(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.template('<div class="header-place"></div>' + '<div class="b-popup-content">' + this.options('content') + '</div>' + '<div class="buttons-place"></div>')(Object.assign({
                options: this.options()
            }, this.options('templateVars'))));
            this.options('afterRenderTemplate') && this.options('afterRenderTemplate')();

            this._header = new __WEBPACK_IMPORTED_MODULE_8__components_popup_header__["a" /* default */](Object(__WEBPACK_IMPORTED_MODULE_3__qwery__["a" /* default */])('.header-place', this.$el), {
                title: this.options('title'),
                textCloseButton: this.options('textCloseButton'),
                onCloseClick: this.destroy.bind(this)
            });

            if (this.options('buttons')) {
                this._buttons = new __WEBPACK_IMPORTED_MODULE_9__components_popup_buttons__["a" /* default */](Object(__WEBPACK_IMPORTED_MODULE_3__qwery__["a" /* default */])('.buttons-place', this.$el), this.options('buttons'));
            }

            this._wrapper = new __WEBPACK_IMPORTED_MODULE_6__components_popup_wrapper__["a" /* default */](this.$el, {
                mode: this.options('mode'),
                scrollbars: (this.options('noPopupScrollbarState') || function () {})()
            });

            this.options('beforeWaitForImages') && this.options('beforeWaitForImages')();
            Object(__WEBPACK_IMPORTED_MODULE_2__common__["e" /* waitForImages */])(this.$el).then(function () {
                _this.updateExtents('popupShow');
                _this.$el.css('visibility', 'visible');

                _this._textareaResizeEventHandler = function (textarea) {
                    if (_this.$el.has(textarea)) _this.updateExtents('popupResize');
                };
                Object(__WEBPACK_IMPORTED_MODULE_2__common__["d" /* onTextareaResize */])(_this._textareaResizeEventHandler);

                __WEBPACK_IMPORTED_MODULE_4__bean__["a" /* default */].on(_this.$el[0], 'click', function (e) {
                    _this._wrapper.popupClicked(true);
                });
                _this._wrapper.options({
                    onClick: _this.destroy.bind(_this)
                });

                _this._shown = true;
                _this.options('afterShow').forEach(function (callback) {
                    return callback();
                });
            });
        }
    }, {
        key: 'updateExtents',
        value: function updateExtents(event) {
            if (this.options('mode') == 'hideViewportScrollbars') {
                this._wrapper.updateExtents();
            } else {
                var hadPositionAbsolute = this.$el.hasClass('position-absolute');

                var minClientHeight = parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']) + this.$el[0].offsetHeight + parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']);

                var minClientWidth = parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']) + this.$el[0].offsetWidth + parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']);

                var willHavePositionAbsolute = document.documentElement.clientWidth < minClientWidth || document.documentElement.clientHeight < minClientHeight;

                if (!(hadPositionAbsolute && willHavePositionAbsolute)) {
                    var top = Math.round((document.documentElement.clientHeight - this.$el[0].offsetHeight) / 3);
                    if (top < parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin'])) top = parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']);
                    if (willHavePositionAbsolute) top = window.pageYOffset + top;
                    this.$el.css('top', top + 'px');

                    var left = Math.round((document.documentElement.clientWidth - this.$el[0].offsetWidth) / 2);
                    if (left < parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin'])) left = parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']);
                    if (willHavePositionAbsolute) left = window.pageXOffset + left;
                    this.$el.css('left', left + 'px');
                }
                var method = willHavePositionAbsolute ? 'addClass' : 'removeClass';
                this.$el[method]('position-absolute');
            }
            if (this.options('onUpdateExtents')) this.options('onUpdateExtents')(event);
        }
    }, {
        key: 'onEnter',
        value: function onEnter() {
            return this._buttons.press('ok-button');
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.options('onDestroy')) {
                var r = this.options('onDestroy')();
                if (r == false) return false;
            }
            this.options('beforeDestroy') && this.options('beforeDestroy')();
            Object(__WEBPACK_IMPORTED_MODULE_2__common__["c" /* offTextareaResize */])(this._textareaResizeEventHandler);
            this._wrapper.destroy();
            this._overlay.destroy();
            this._shown = false;
            this.options('afterDestroy') && this.options('afterDestroy')();
        }
    }, {
        key: 'options',
        value: function options(_options) {
            if (_options != null && typeof _options != 'string') {
                var afterShow = (this.options('afterShow') || []).concat(_options['afterShow'] || []);
                Object.assign(this._options, _options, { afterShow: afterShow });
            }
            return _options && typeof _options == 'string' ? this._options[_options] : this._options;
        }
    }, {
        key: 'getBoundingClientRect',
        value: function getBoundingClientRect() {
            return this.$el[0].getBoundingClientRect();
        }
    }, {
        key: 'maxContentWidth',
        value: function maxContentWidth() {
            var r = this._wrapper.maxContentWidth() - (this.options('mode') != 'hideViewportScrollbars' ? 2 * parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']) : 0) - parseFloat(this.$el.css('padding-left')) - parseFloat(this.$el.css('padding-right'));
            return Math.max(r, this._header.$el[0].offsetWidth);
        }
    }, {
        key: 'maxContentHeight',
        value: function maxContentHeight() {
            return this._wrapper.maxContentHeight() - (this.options('mode') != 'hideViewportScrollbars' ? 2 * parseFloat(__WEBPACK_IMPORTED_MODULE_1__front_end_vars__["a" /* default */]['popup-min-margin']) : 0) - parseFloat(this.$el.css('padding-top')) - this._header.height() - parseFloat(this._header.$el.css('margin-bottom')) - parseFloat(this.$el.css('padding-bottom'));
        }
    }, {
        key: 'shown',
        value: function shown() {
            return this._shown;
        }
    }]);

    return Popup;
}();

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),

/***/ "GIvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("aEn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__above_the_fold_css__ = __webpack_require__("+Fcr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__above_the_fold_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__above_the_fold_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__makosh_assets_qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__makosh_assets_bean__ = __webpack_require__("+l4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_swf_popup_js__ = __webpack_require__("/UWE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_img_popup_js__ = __webpack_require__("x4SL");








if (document.querySelector('.b-page.cradle-page')) {
    var $cradlePage = Object(__WEBPACK_IMPORTED_MODULE_2__makosh_assets_qwery__["a" /* default */])('.b-page.cradle-page');
    var $showSwfLink = Object(__WEBPACK_IMPORTED_MODULE_2__makosh_assets_qwery__["a" /* default */])('.show-swf-link', $cradlePage);

    __WEBPACK_IMPORTED_MODULE_3__makosh_assets_bean__["a" /* default */].on($showSwfLink[0], 'click', function () {
        return new __WEBPACK_IMPORTED_MODULE_4__components_swf_popup_js__["a" /* default */]({
            url: $showSwfLink[0].dataset['url'],
            width: $showSwfLink[0].dataset['width'],
            height: $showSwfLink[0].dataset['height']
        });
    });
}
if (document.querySelector('.b-page.cradle-page, .b-page.poncho-page')) {
    var $page = Object(__WEBPACK_IMPORTED_MODULE_2__makosh_assets_qwery__["a" /* default */])('.b-page.cradle-page, .b-page.poncho-page');

    __WEBPACK_IMPORTED_MODULE_3__makosh_assets_bean__["a" /* default */].on($page[0], 'click', '.img-popup-link', function (e) {
        return new __WEBPACK_IMPORTED_MODULE_5__components_img_popup_js__["a" /* default */]({
            url: Object(__WEBPACK_IMPORTED_MODULE_2__makosh_assets_qwery__["a" /* default */])(e.target).selfOrParent('a')[0].dataset['url']
        });
    });
}

/***/ }),

/***/ "IMjp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = waitForImages;
/* harmony export (immutable) */ __webpack_exports__["b"] = addToBasket;
/* harmony export (immutable) */ __webpack_exports__["d"] = onTextareaResize;
/* harmony export (immutable) */ __webpack_exports__["c"] = offTextareaResize;
/* harmony export (immutable) */ __webpack_exports__["a"] = addAfterPasteEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("aEn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("3ghm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird__ = __webpack_require__("jWXr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bean__ = __webpack_require__("+l4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axios__ = __webpack_require__("PBm6");








function waitForImages(el) {
    var images = document.querySelectorAll('img');
    return __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a.all(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.compact(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(images, function (img) {
        if (img.complete) {
            return;
        } else return new __WEBPACK_IMPORTED_MODULE_2_bluebird___default.a(function (resolve, reject) {
            img.addEventListener('load', function () {
                resolve();
            });
        });
    })));
}

function addToBasket(product_id, size_id) {
    return product_id ? __WEBPACK_IMPORTED_MODULE_5__axios__["a" /* default */].post('/basket', __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify({
        product_id: product_id,
        size_id: size_id,
        amount: 1
    })) : __WEBPACK_IMPORTED_MODULE_5__axios__["a" /* default */].get('/basket');
}

var callbacks = [];
var textarea = void 0;

function mousedownEventHandler(e) {
    if (e.target.tagName == 'TEXTAREA') textarea = e.target;
}

function mouseupEventHandler(e) {
    if (textarea) {
        callbacks.forEach(function (callback) {
            callback(textarea);
        });
    }
    textarea = null;
}

function onTextareaResize(callback) {
    if (!callbacks.length) {
        __WEBPACK_IMPORTED_MODULE_4__bean__["a" /* default */].on(window, 'mousedown', mousedownEventHandler);
        __WEBPACK_IMPORTED_MODULE_4__bean__["a" /* default */].on(window, 'mouseup', mouseupEventHandler);
    }
    callbacks.push(callback);
}

function offTextareaResize(callback) {
    callbacks = callbacks.filter(function (c) {
        return c != callback;
    });
    if (!callbacks.length) {
        __WEBPACK_IMPORTED_MODULE_4__bean__["a" /* default */].off(window, 'mousedown', mousedownEventHandler);
        __WEBPACK_IMPORTED_MODULE_4__bean__["a" /* default */].off(window, 'mouseup', mouseupEventHandler);
    }
}

function addAfterPasteEvent(el) {
    var $el = Object(__WEBPACK_IMPORTED_MODULE_3__qwery__["a" /* default */])(el);
    __WEBPACK_IMPORTED_MODULE_4__bean__["a" /* default */].on($el[0], 'paste', function (e) {
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_4__bean__["a" /* default */].fire(e.target, 'afterpaste');
        });
    });
}

/***/ }),

/***/ "IoA1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__front_end_vars__ = __webpack_require__("uvj3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bean__ = __webpack_require__("+l4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_popup_manager__ = __webpack_require__("BTMb");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var Wrapper = function () {
    function Wrapper(popup) {
        var _this = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Wrapper);

        this.$popup = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(popup);
        this._options = options;
        if (this.options('mode') == 'hideViewportScrollbars') {
            this.$el = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(document.createElement('div'));
            this.$el.attr('class', 'popup-wrapper');
            if (this.options('scrollbars')['vert']) this.$el.css('overflow-y', 'scroll');
            if (this.options('scrollbars')['horz']) this.$el.css('overflow-x', 'scroll');

            var $popupWrapper2 = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(document.createElement('table'));
            $popupWrapper2.attr('class', 'popup-wrapper-2');

            var row = $popupWrapper2[0].insertRow();

            this.$popupWrapper3 = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(row.insertCell());
            this.$popupWrapper3.attr('class', 'popup-wrapper-3');

            this.$el.append($popupWrapper2);
            this.$popupWrapper3.append(this.$popup);
            document.body.appendChild(this.$el[0]);

            __WEBPACK_IMPORTED_MODULE_2__bean__["a" /* default */].on(this.$el[0], 'click', function () {
                if (!_this.popupClicked()) _this.options('onClick')();
                _this.popupClicked(false);
            });
        } else {
            document.body.appendChild(this.$popup[0]);
        }
    }

    _createClass(Wrapper, [{
        key: 'popupClicked',
        value: function popupClicked(_popupClicked) {
            if (_popupClicked != null) this._popupClicked = _popupClicked;
            return this._popupClicked;
        }
    }, {
        key: 'updateExtents',
        value: function updateExtents() {
            var paddingTop = (this.$el[0].clientHeight - this.$popup[0].offsetHeight) / 3 - parseFloat(__WEBPACK_IMPORTED_MODULE_0__front_end_vars__["a" /* default */]['popup-min-margin']);
            if (paddingTop < 0) paddingTop = 0;
            this.$el.css('padding-top', paddingTop + 'px');
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            if (this.options('mode') == 'hideViewportScrollbars') this.$el.remove();else this.$popup.remove();
        }
    }, {
        key: 'options',
        value: function options(_options) {
            if (_options != null && typeof _options != 'string') Object.assign(this._options, _options);
            return _options && typeof _options == 'string' ? this._options[_options] : this._options;
        }
    }, {
        key: 'maxContentWidth',
        value: function maxContentWidth() {
            return this.options('mode') == 'hideViewportScrollbars' ? __WEBPACK_IMPORTED_MODULE_3__components_popup_manager__["a" /* default */].noPopupViewportClientWidth() - parseFloat(this.$popupWrapper3.css('padding-left')) - parseFloat(this.$popupWrapper3.css('padding-right')) : document.documentElement.clientWidth;
        }
    }, {
        key: 'maxContentHeight',
        value: function maxContentHeight() {
            return this.options('mode') == 'hideViewportScrollbars' ? __WEBPACK_IMPORTED_MODULE_3__components_popup_manager__["a" /* default */].noPopupViewportClientHeight() - parseFloat(this.$popupWrapper3.css('padding-top')) - parseFloat(this.$popupWrapper3.css('padding-bottom')) : document.documentElement.clientHeight;
        }
    }]);

    return Wrapper;
}();

/* harmony default export */ __webpack_exports__["a"] = (Wrapper);

/***/ }),

/***/ "MWVq":
/***/ (function(module, exports) {

module.exports = { "thumb-width-l": "300px", "thumb-width-m": "140px", "thumb-width-s": "72px", "thumb-s-spacing": "4px", "DISCOUNT": 0.05, "DISCOUNT_THRESHOLD": 2000 };

/***/ }),

/***/ "OBpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'transition': 'ease-in-out .15s',
    'max-text-width': '500px',
});


/***/ }),

/***/ "PBm6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_notie_dist_notie_css__ = __webpack_require__("L+ps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_notie_dist_notie_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_notie_dist_notie_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("hH1D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mIGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_notie__ = __webpack_require__("Cs1V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_notie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_notie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird__ = __webpack_require__("jWXr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bluebird__);







__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.post['X-CSRFToken'] = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('csrftoken');
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.patch['X-CSRFToken'] = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('csrftoken');
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.delete['X-CSRFToken'] = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('csrftoken');
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(null, function (error) {
    if (!error.response) __WEBPACK_IMPORTED_MODULE_3_notie___default.a.alert({ type: 'error', text: 'помилка при роботі з мережою' });else __WEBPACK_IMPORTED_MODULE_3_notie___default.a.alert({ type: 'error', text: 'помилка виконання запиту до сервера' });
    return __WEBPACK_IMPORTED_MODULE_4_bluebird___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/***/ }),

/***/ "h437":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = $;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qwery__ = __webpack_require__("VahM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qwery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qwery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bonzo__ = __webpack_require__("9gyz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bonzo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bonzo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_traversty__ = __webpack_require__("zHJT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_traversty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_traversty__);




__WEBPACK_IMPORTED_MODULE_1_bonzo___default.a.setQueryEngine(__WEBPACK_IMPORTED_MODULE_0_qwery___default.a);

function $(selector, opt_root) {
    return __WEBPACK_IMPORTED_MODULE_1_bonzo___default()(__WEBPACK_IMPORTED_MODULE_0_qwery___default()(selector, opt_root));
};

__WEBPACK_IMPORTED_MODULE_1_bonzo___default.a.aug({
    has: function has(el) {
        return __WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).has(el).length;
    },

    parent: function parent() {
        var sel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

        return $(__WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).up(sel, 0));
    },

    selfOrParent: function selfOrParent() {
        var sel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

        return $(__WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).closest(sel, 0));
    },

    children: function children() {
        var sel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

        return $(__WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).children(sel));
    },

    descendants: function descendants() {
        var sel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

        return $(__WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).down(sel));
    },

    prev: function prev() {
        var sel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

        return $(__WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).prev(sel, 0));
    },

    next: function next() {
        var sel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

        return $(__WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).next(sel, 0));
    },

    siblings: function siblings() {
        var sel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

        return $(__WEBPACK_IMPORTED_MODULE_2_traversty___default()(this).siblings(sel));
    },

    toArray: function toArray() {
        return this.map(function (x) {
            return x;
        });
    }
});

/***/ }),

/***/ "kAvu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bean__ = __webpack_require__("+l4E");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Overlay = function () {
    function Overlay() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Overlay);

        this._options = options;
        this.$el = Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(document.createElement('div'));
        this.$el.attr('class', 'b-popup-overlay');
        document.body.appendChild(this.$el[0]);
        __WEBPACK_IMPORTED_MODULE_1__bean__["a" /* default */].on(this.$el[0], 'click', this._options['onClick']);
    }

    _createClass(Overlay, [{
        key: 'destroy',
        value: function destroy() {
            this.$el.remove();
        }
    }]);

    return Overlay;
}();

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),

/***/ "rtXA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bean__ = __webpack_require__("+l4E");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var Button = function () {
    function Button(el) {
        var _this = this;

        _classCallCheck(this, Button);

        if (Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(el).data('button')) return Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(el).data('button');
        Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(el).data('button', this);
        this.$el = Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(el);
        this.disabled(this.$el.hasClass('disabled'));
        if (!this.disabled()) this.$el.attr('tabindex', 0);
        __WEBPACK_IMPORTED_MODULE_1__bean__["a" /* default */].on(this.$el[0], 'click', function (e) {
            _this.$el[0].dispatchEvent(new CustomEvent('press', {
                bubbles: true,
                detail: {
                    type: 'mouse',
                    initialEvent: e
                }
            }));
        });
        __WEBPACK_IMPORTED_MODULE_1__bean__["a" /* default */].on(this.$el[0], 'keydown', function (e) {
            switch (e.key) {
                case ' ':
                case 'Enter':
                    if (_this._shouldFirePress(e.key)) {
                        if (e.key == ' ') e.preventDefault();
                        _this.$el[0].dispatchEvent(new CustomEvent('press', {
                            bubbles: true,
                            detail: {
                                type: 'keyboard',
                                initialEvent: e
                            }
                        }));
                    }
                    break;
            }
        });
    }

    _createClass(Button, [{
        key: '_shouldFirePress',
        value: function _shouldFirePress(key) {
            return [' ', 'Enter'].includes(key);
        }
    }, {
        key: 'disabled',
        value: function disabled(_disabled) {
            if (_disabled != null) {
                this.$el[_disabled ? 'addClass' : 'removeClass']('disabled');
                if (_disabled) this.$el.removeAttr('tabindex');else this.$el.attr('tabindex', 0);
                this._disabled = _disabled;
            }
            return this._disabled;
        }
    }, {
        key: 'focus',
        value: function focus() {
            this.$el.focus();
        }
    }]);

    return Button;
}();

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "uvj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_front_end_vars__ = __webpack_require__("OBpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__front_end_vars_gen__ = __webpack_require__("MWVq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__front_end_vars_gen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__front_end_vars_gen__);


var spacingL = '50px';
/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__common_front_end_vars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__front_end_vars_gen___default.a, {
    'popup-min-margin': '20px',
    'left-block-width': '250px',
    'spacing-l': spacingL,
    'page-spacing': spacingL
}));

/***/ }),

/***/ "x4SL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("aEn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__makosh_assets_components_popup_popup__ = __webpack_require__("F8dO");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ImgPopup = function (_Popup) {
    _inherits(ImgPopup, _Popup);

    function ImgPopup() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, ImgPopup);

        var _this = _possibleConstructorReturn(this, (ImgPopup.__proto__ || Object.getPrototypeOf(ImgPopup)).call(this, { noInit: true }));

        _this.init(Object.assign({
            class: 'img-popup group',
            content: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.template('<img src="<%- url %>">')(options)
        }, options));
        return _this;
    }

    return ImgPopup;
}(__WEBPACK_IMPORTED_MODULE_1__makosh_assets_components_popup_popup__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ImgPopup);

/***/ }),

/***/ "xjfE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__qwery__ = __webpack_require__("h437");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var Viewport = function () {
    function Viewport() {
        _classCallCheck(this, Viewport);

        this._hidden = false;
        this.$siteInnerContainer = Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(document.createElement('div'));
        this.$siteInnerContainer.attr('class', 'site-inner-container');
        while (document.body.childNodes.length) {
            this.$siteInnerContainer[0].appendChild(document.body.childNodes[0]);
        }
        this.$siteOuterContainer = Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(document.createElement('div'));
        this.$siteOuterContainer.attr('class', 'site-outer-container');
        this.$siteOuterContainer.append(this.$siteInnerContainer);
        document.body.appendChild(this.$siteOuterContainer[0]);
    }

    _createClass(Viewport, [{
        key: 'showScrollbars',
        value: function showScrollbars() {
            this.$siteInnerContainer.css('width', '');
            this.$siteInnerContainer.css('height', '');
            this.$siteInnerContainer.css('margin-left', '');
            this.$siteInnerContainer.css('margin-top', '');
            this.$siteOuterContainer.css('width', '');
            this.$siteOuterContainer.css('height', '');
            Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(document.body).css('min-width', '');
            Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(document.body).css('overflow-y', '');
            window.scroll(this.noPopupPageXOffset(), this.noPopupPageYOffset());
            this._hidden = false;
        }
    }, {
        key: 'hideScrollbars',
        value: function hideScrollbars() {
            this._noPopupVertScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            this._noPopupHorzScrollbarHeight = window.innerHeight - document.documentElement.clientHeight;
            this._noPopupSiteWidth = document.body.offsetWidth;
            this._noPopupSiteHeight = document.body.offsetHeight;
            this._noPopupPageXOffset = window.pageXOffset;
            this._noPopupPageYOffset = window.pageYOffset;
            Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(document.body).css('min-width', 'auto');
            Object(__WEBPACK_IMPORTED_MODULE_0__qwery__["a" /* default */])(document.body).css('overflow-y', 'auto');
            this.$siteInnerContainer.css('margin-left', -this._noPopupPageXOffset + 'px');
            this.$siteInnerContainer.css('margin-top', -this._noPopupPageYOffset + 'px');
            this._hidden = true;
            this.updateExtents();
        }
    }, {
        key: 'updateExtents',
        value: function updateExtents() {
            this.$siteOuterContainer.css('width', window.innerWidth - this._noPopupVertScrollbarWidth + 'px');
            this.$siteOuterContainer.css('height', window.innerHeight - this._noPopupHorzScrollbarHeight + 'px');
            if (this.$siteInnerContainer[0].style.width && this.$siteOuterContainer[0].offsetWidth > this._noPopupSiteWidth - this.noPopupPageXOffset()) this.$siteInnerContainer.css('width', '');else if (!this.$siteInnerContainer[0].style.width && this.$siteOuterContainer[0].offsetWidth < this._noPopupSiteWidth - this.noPopupPageXOffset()) this.$siteInnerContainer.css('width', this._noPopupSiteWidth + 'px');
            if (this.$siteInnerContainer[0].style.height && this.$siteOuterContainer[0].offsetHeight > this._noPopupSiteHeight - this.noPopupPageYOffset()) this.$siteInnerContainer.css('height', '');else if (!this.$siteInnerContainer[0].style.height && this.$siteOuterContainer[0].offsetHeight < this._noPopupSiteHeight - this.noPopupPageYOffset()) this.$siteInnerContainer.css('height', this._noPopupSiteHeight + 'px');
        }
    }, {
        key: 'noPopupScrollbarState',
        value: function noPopupScrollbarState() {
            return this.scrollbarsHidden() ? { vert: this._noPopupVertScrollbarWidth > 0,
                horz: this._noPopupHorzScrollbarHeight > 0 } : { vert: window.innerHeight > document.documentElement.clientHeight,
                horz: window.innerWidth > document.documentElement.clientWidth };
        }
    }, {
        key: 'noPopupPageXOffset',
        value: function noPopupPageXOffset() {
            return this.scrollbarsHidden() ? this._noPopupPageXOffset : window.pageXOffset;
        }
    }, {
        key: 'noPopupPageYOffset',
        value: function noPopupPageYOffset() {
            return this.scrollbarsHidden() ? this._noPopupPageYOffset : window.pageYOffset;
        }
    }, {
        key: 'noPopupClientWidth',
        value: function noPopupClientWidth() {
            return this.scrollbarsHidden() ? this.$siteOuterContainer[0].offsetWidth : document.documentElement.clientWidth;
        }
    }, {
        key: 'noPopupClientHeight',
        value: function noPopupClientHeight() {
            return this.scrollbarsHidden() ? this.$siteOuterContainer[0].offsetHeight : document.documentElement.clientHeight;
        }
    }, {
        key: 'scrollbarsHidden',
        value: function scrollbarsHidden() {
            return this._hidden;
        }
    }]);

    return Viewport;
}();

/* harmony default export */ __webpack_exports__["a"] = (Viewport);

/***/ }),

/***/ "zweD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("aEn6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__qwery__ = __webpack_require__("h437");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bean__ = __webpack_require__("+l4E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_button__ = __webpack_require__("rtXA");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var Header = function () {
    function Header(el) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Header);

        this._options = options;
        this.$el = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(document.createElement('div'));
        this.$el.attr('class', 'b-popup-header');
        this.$el.html(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.template('<span role="button" class="close-button">' + '<% if (options["textCloseButton"]) { %>' + '×' + '<% } %>' + '</span>' + '<div class="title">' + '<%- options["title"] %>' + '</div>')({ options: this._options }));
        Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])(el).replaceWith(this.$el);
        var $closeButton = Object(__WEBPACK_IMPORTED_MODULE_1__qwery__["a" /* default */])('.close-button', this.$el);
        this._closeButton = new __WEBPACK_IMPORTED_MODULE_3__components_button__["a" /* default */]($closeButton);

        __WEBPACK_IMPORTED_MODULE_2__bean__["a" /* default */].on($closeButton[0], 'press', this._options['onCloseClick']);
    }

    _createClass(Header, [{
        key: 'height',
        value: function height() {
            return this.$el[0].offsetHeight;
        }
    }]);

    return Header;
}();

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ })

},["GIvn"]);


// WEBPACK FOOTER //
// legacy-c7097d6b5b0ee7071b2e.js